import { ref } from "vue";
import { useRouter } from "vue-router";
import { TicketService } from "@/services/TicketService";

/**
 * @composable useHomeTickets
 * @description Gestisce il caricamento dei ticket aperti per la Home Page.
 * @returns {{
 *   openTickets: import('vue').Ref<Array>,
 *   loaded: import('vue').Ref<boolean>,
 *   hasError: import('vue').Ref<boolean>,
 *   loadOpenTickets: Function
 * }}
 */
export function useHomeTickets() {
  const openTickets = ref([]);  // → Array<Ticket>: lista ticket aperti (Incident + ChangeRequest, stati Open/On Hold)
  const loaded = ref(false);    // → Boolean: true quando il caricamento è completato (convenzione loaded=true → dati disponibili)
  const hasError = ref(false);  // → Boolean: true se il caricamento è fallito (diverso da "nessun ticket")
  const router = useRouter();

  async function loadOpenTickets() {
    loaded.value = false;
    hasError.value = false;
    const { data, error, status } = await TicketService.getTicketList({
      page_size: 10,
      page: 1,
      service: "Incident,ChangeRequest",
      status: "Open,On Hold",
    });

    if (error === "invalid token") {
      router.push({ name: "MyLogin" });
      return;
    }

    // 404 = nessun ticket aperto: lista vuota; ogni altro errore (anche 403) → InlineError
    if (error && status !== 404) {
      console.error(error);
      hasError.value = true;
      openTickets.value = [];
    } else {
      openTickets.value = data ?? [];
    }
    loaded.value = true;
  }

  return { openTickets, loaded, hasError, loadOpenTickets };
}